import firebase from 'firebase';
import firestore from 'firebase/firestore';

  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyBUCVz3Eotfij8GQAYM-ugoqZs46hKpnjU",
    authDomain: "quiz-2d6e3.firebaseapp.com",
    databaseURL: "https://quiz-2d6e3.firebaseio.com",
    projectId: "quiz-2d6e3",
    storageBucket: "quiz-2d6e3.appspot.com",
    messagingSenderId: "656592266333",
    appId: "1:656592266333:web:dcd4abf14123623e2619b4",
    measurementId: "G-HBM9WE0BPD"
  };
  // Initialize Firebase


const firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics();
//exporta firestore
export default firebaseApp.firestore();
